const DEFAULT_LANGUAGE = 'en';
const LANGUAGE_KEY = 'lang';

const getSiteLanguage = () => {
    return "en"
}

const setSiteLanguage = (lang) => {
    localStorage.setItem(LANGUAGE_KEY, lang || DEFAULT_LANGUAGE);
}

const handleLanguage = (location, navigate) => {
    // The function is called in app.tsx and in that scope, it seems that 
    // we don't have access to useparams, so we are using location,
    // to find the language
    const locationParts = location.pathname.split('/');
    const lang = locationParts.length > 1 ? locationParts[1] : null;

    // if (!lang) {
    //     navigate('/en');
    // }

    // setSiteLanguage(lang);
}

const buildUrl = (link) => {
    const lang = getSiteLanguage();

    if (link.url) {
        return link.url;
    }

    return "/" + link.postType + "/" + link.slug
}

const constructDate = (start_date, end_date, defaultDate)=> {

  if( start_date != null && end_date != null) {
      const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]

      const isoStartDate = (new Date(start_date))
      const startMonth = months[isoStartDate.getMonth()];
      const startDate = isoStartDate.getDate()
      const startYear = isoStartDate.getFullYear()

      const isoEndDate = (new Date(end_date))
      const endMonth= months[isoEndDate.getMonth()];
      const endDate = isoEndDate.getDate()
      const endYear =isoEndDate.getFullYear()


      if ( (startMonth == endMonth) && (startDate == endDate) && (startYear == endYear)) {
          return `${startDate} ${startMonth} ${startYear}`
      } else {
          return `${startDate} ${startMonth} ${startYear} - ${endDate} ${endMonth} ${endYear}`
      }
  }
 
  return (new Date(defaultDate).toLocaleDateString())
} 

export {
    getSiteLanguage,
    setSiteLanguage,
    buildUrl,
    handleLanguage,
    constructDate
};